// src/services/coinStoreService.js — buying coin packs (functions/coinStore.js)

import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase/firebaseConfig";

export const DEFAULT_PACKS = [
  { id: "coins-100", coins: 100, cents: 399 },
  { id: "coins-250", coins: 250, cents: 499 },
  { id: "coins-500", coins: 500, cents: 699 },
  { id: "coins-1000", coins: 1000, cents: 999, best: true },
];

export const money = (cents) => `$${(Number(cents) / 100).toFixed(2)}`;

export const getCoinPacks = async () => {
  try {
    const res = await httpsCallable(functions, "getCoinPacks")();
    return res?.data?.packs?.length ? res.data.packs : DEFAULT_PACKS;
  } catch {
    return DEFAULT_PACKS;
  }
};

export const startCoinCheckout = async (packId, returnPath) => {
  const res = await httpsCallable(functions, "createCoinCheckout")({ packId, origin: window.location.origin, returnPath: returnPath || window.location.pathname });
  if (res?.data?.url) window.location.href = res.data.url;
};

export const confirmCoinPurchase = async (sessionId) => {
  const res = await httpsCallable(functions, "confirmCoinPurchase")({ sessionId });
  return res?.data || null;
};
